import request from '@/utils/request'

// 作業可能日調整詳細-情報(協力会社)
export function workableDateRequestInfo(possibleDateDetailId) {
  return request({
    url: `/api/workableDateRequest/partner/${possibleDateDetailId}`,
    method: 'get',
  })
}
// 作業可能日調整詳細-日程情報(協力会社)
export function getWorkableDateTimeList(data) {
  return request({
    url: `/api/workableDateRequest/partner/calendar`,
    method: 'post',
    data,
  })
}
// 作業可能日調整詳細-日程回答(協力会社)
export function submitAnswerSchedule(data) {
  return request({
    url: `/api/workableDateRequest/partner/answer/schedule`,
    method: 'post',
    data,
  })
}

// 作業予定
export function queryCountByChangeStatus(id = '') {
  return request({
    url: `/api/works/top/queryCountByChangeStatus/${id}`,
    method: 'get',
  })
}
// 作業実績
export function queryCountByInputStatus(id = '') {
  return request({
    url: `/api/reportTop/resultDateInputStatusPartner${id}/`,
    method: 'get',
  })
}
// (大和ハウス)作業実績 - 実施日入力状況 まとめるCount
export function reportTop(id) {
  return request({
    url: `/api/reportTop/${id}`,
    method: 'get',
  })
}
// (大和ハウス)作業報告書 正式版報告状況 まとめるCount
export function officalReportStatus() {
  return request({
    url: `/api/reportTop/officalReportStatusPartner`,
    method: 'get',
  })
}
// (大和ハウス)作業報告書 速報版報告状況 まとめるCount
export function preReportStatus() {
  return request({
    url: `/api/reportTop/preReportStatusPartner`,
    method: 'get',
  })
}
